module.exports = __webpack_public_path__ + "static/media/za.b0c63a84.webp";